/**
 *
 * Mixin for stores that only allow a single item to be visible at a time (e.g. a single date picker, or modal can be shown at once)
 *
 */
export default {
  setVisibility(key, visible) {
    var prev = this.getState().map(() => false),
      next = prev.set(key, visible);

    this.setStateAndTrigger(next);
  },
};
